import { IBasicInfoProperty, ILocProps } from '../../../components/FormContainers/applicationLocation/Types';
import { ILocationDetails } from '../../generalTypes';
import { markerRadioOptions } from './selectOptions';

export const initialValues = (locationDetails?: ILocationDetails | undefined)
  : IBasicInfoProperty => {
  const convertBooleanToStringBoolean = (value: boolean | undefined) => {
    if (value === null || value === undefined) return null;
    if (value) return 'true';
    if (!value) return 'false';
  };

  return {
    title_property: locationDetails?.title || '',
    category_lvl1: locationDetails?.location_category_level_1 || [],
    category_loc: locationDetails?.location_category_level_2 || [],
    category_lvl3: locationDetails?.location_category_level_3 || [],
    info_property: locationDetails?.info || '',
    info_property_en: locationDetails?.info_en || '',
    amea: convertBooleanToStringBoolean(locationDetails?.amea_access) || null,
    heavy_vehicles: convertBooleanToStringBoolean(locationDetails?.overweight_vehicle_access)
      || null,
    limitations: locationDetails?.restrictions || '',
    limitations_en: locationDetails?.restrictions_en || '',
    keywords: locationDetails?.tags || [],
    keywords_gr: locationDetails?.tags_gr || [],
    marker: locationDetails?.show_on_map || markerRadioOptions()[0]?.value,
    region: locationDetails?.region_id || [],
    addressPostalCode: locationDetails?.tk || '',
    addressName: locationDetails?.address || null,
    addressNumber: locationDetails?.address_number || null,
    lat: locationDetails?.latitude || null,
    lon: locationDetails?.longitude || null,
    fileThumbnail: [locationDetails?.thumbnail] || null,
    otherMedia: locationDetails?.media || null,
    name: locationDetails?.name || '',
    surname: locationDetails?.lastname || '',
    phone: locationDetails?.mobile || '',
    email: locationDetails?.email || '',
    website: locationDetails?.website || '',
    attachments: locationDetails?.attached_files || null,
    licensing: locationDetails?.licensing || '',
    licensing_en: locationDetails?.licensing_en || '',
    preinserted: locationDetails?.preinserted || false,
  };
};

export const createLocationFormInitialValues: ILocProps = {
  title: '',
  afm: '',
  email: '',
  phone_number: '',
  dateFrom: '',
  dateTo: '',
  hours: [],
  info: '',
  name: null,
  surname: null,
  tel: '',
  email_manage: ''
};